import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ko';

dayjs.extend(relativeTime);

export function communintyDateFormat(dateTime: any) {
  dayjs.locale('ko'); // 한국어 로케일을 설정합니다.
  const time = dayjs(dateTime).fromNow();
  return time;
}

export const dateForamt = (date: Date) => {
  date = new Date(date);
  return (
    date.toISOString().split('T')[0].replace('-', '년 ').replace('-', '월 ') +
    '일'
  );
};

export function formatSuccessDateTime(inputDateTime: string) {
  const inputDate = new Date(inputDateTime);

  // 년, 월, 일, 시, 분, 초를 추출
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더하고 2자리로 패딩
  const day = String(inputDate.getDate()).padStart(2, '0');
  const hours = String(inputDate.getHours()).padStart(2, '0');
  const minutes = String(inputDate.getMinutes()).padStart(2, '0');
  const seconds = String(inputDate.getSeconds()).padStart(2, '0');

  // 원하는 포맷으로 조합
  const formattedDateTime = `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;

  return formattedDateTime;
}

export function formatDateToKorean(dateString: string) {
  // 입력된 날짜 문자열을 Date 객체로 파싱
  const date = new Date(dateString);

  // 년, 월, 일을 추출
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth()는 0부터 시작하므로 1을 더해줍니다.
  const day = date.getDate();

  // 년, 월, 일을 "yyyy년 mm월 dd일" 형식으로 변환
  const formattedDate = year + '년 ' + month + '월 ' + day + '일';

  return formattedDate;
}
